export default "__VITE_ASSET__DqWOhetN__"